"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _item = _interopRequireDefault(require("./item"));

var _utils = require("../../utils");

var _jsxRuntime = require("react/jsx-runtime");

var _excluded = ["children", "className", "tag"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var styles = {
  "container": "styles-container-2d0MF",
  "fixed": "styles-fixed-3La6G",
  "item": "styles-item-1WhX8",
  "brand": "styles-brand-1otuI"
};

var Brand = function Brand(_ref) {
  var children = _ref.children,
      className = _ref.className,
      _ref$tag = _ref.tag,
      tag = _ref$tag === void 0 ? 'a' : _ref$tag,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_item["default"], _objectSpread(_objectSpread({
    className: _utils.classNames.use('brand').from(styles).join(className)
  }, restProps), {}, {
    tag: tag,
    children: children
  }));
};

Brand.displayName = "Brand";
var _default = Brand;
exports["default"] = _default;